import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertIcoToPng() {
  return (
    <ImageConverterTemplate
      sourceFormat="ICO"
      targetFormat="PNG"
      acceptTypes=".ico,image/x-icon,image/vnd.microsoft.icon"
      slug="convert-ico-to-png"
      gradientColors="from-cyan-500 to-blue-500"
      accentColor="blue"
    />
  );
}
